<div class="container mt-2 pb-4">

  <div class="row">

    <div class="betting-category mb-2">
      <div class="card-body px-0">
        <div class="d-flex">
          <div class="race-icon bordered mr-2">
            <span class="icon" style="color: #000;"
              [ngClass]="[kironResults[0]?.eventName.indexOf('Greyhound')!=-1 ? 'icon-greyhound':'icon-horse']"></span>
          </div>
          <div class="d-flex flex-column">
            <span class="t">Event {{kironResults[0]?.eventCode}} - {{kironResults[0]?.offTimeLocal}}</span>
            <span class="t-faded t-smaller">{{kironResults[0]?.eventName}}</span>
          </div>
          <div class="extra d-flex">
            <div class="d-flex flex-column align-items-end mt-2" style="color: #2d3436;">
              <span class="t">{{'COMMON.RESULTS' | translate}} </span>
            </div>

            <a href="#" data-toggle="modal" data-target="#raceresultModal" class="btn btn-tertiary icon ml-2">
              <span class="icon icon-menu"></span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div (click)="video_clicked()" class="live btn mb-2">{{'COMMON.WATCH-LIVE-STREAM' | translate}}</div>

    <!-- 1st table -->
    <div class="race-preview shadow p-0 mb-2" *ngFor="let meeting of kironNewData; index as i">
      <div class="race-header bg-fill-secondary text-white">
        <div class="race-icon mr-2" style="margin:0 !important">
          <span class="icon"
            [ngClass]="[meeting.eventName.indexOf('Greyhound')!=-1 ? 'icon-greyhound':'icon-horse']"></span>
        </div>
        <div class="race-info">
          <div class="race-name text-uppercase">{{meeting.eventName}}</div>
          <div class="race-description text-uppercase">{{'COMMON.GAME' | translate}}: {{meeting.eventCode}}</div>
        </div>
        <div class="race-extra">
          {{meeting.eventTime.substr(0,5)}}
          <span class="secondary">{{meeting.eventLocalDate}}</span>
        </div>
      </div>


      <div class="race-content">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let item of meeting.selections">
            <div class="avatar-wrapper">
              <div [ngClass]="{'red-button': checkKr3Color(item) == 'red', 'blue-button' : checkKr3Color(item) == 'blue' ,
              'green-button': checkKr3Color(item) == 'green', 'yellow-button' : checkKr3Color(item) == 'yellow' ,
              'black-button': checkKr3Color(item) == 'black', 'purple-button' : checkKr3Color(item) == 'purple' ,
              'orange-button': checkKr3Color(item) == 'orange', 'white-button' : checkKr3Color(item) == 'white'
               }"
               class="number">{{item.selectionNumber}}</div>
              <img src="{{'data:image/png;base64,'+item.jerseyIcon}}" 
              onerror="this.src='assets/icon/kiron3no.png'" alt="Wile" class="avatar">
            </div>
            <div class="info">
              <div class="title text-black" style="font-size: 17px;">{{item.name}}</div>
            </div>
            <div class="extra">
              <!-- <button disabled class="btn btn-tertiary">{{item.priceOdds.priceDecimal}}</button> -->
              <button (click)="setSPOdd(item)" 
              [ngClass]="{'btn-tertiaryActive':item.clicked == true }"
                class="btn btn-tertiary plr-5">SELECT</button>
            </div>
          </li>
        </ul>
      </div>



      <!-- Modal -->
      <div class="modal fade" id="raceresultModal" data-backdrop="false" tabindex="100000" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="margin-left: 0px;margin-right: 0px;">
          <div class="modal-content" style="margin-top: 200px;margin-bottom: 100px;">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{'COMMON.RESULTS' | translate}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span style="font-size: 35px;" aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div *ngFor="let item of kironResults" class="race-preview shadow p-0 mb-2">
                <div class="race-header bg-fill-secondary text-white">
                  <div class="race-info">
                    <div class="race-name text-uppercase">{{item.eventName}}</div>
                    <div class="race-description text-uppercase">Game: {{item.eventCode}}</div>
                  </div>
                  <div class="race-extra">
                    {{item.eventTimeUTC.substr(11,5)}}
                    <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span>
                  </div>
                </div>

                <div class="race-content">

                  <div *ngIf="item.isKLH" class="race-content klh" >
                    <table class="racing-table table-borderless table-striped">
                      <thead>
                        <tr>
                          <th></th>
                          <th class="text-left">PAYS</th>
                          <th></th>
                          <th class="text-left">RESULT</th>
                        </tr>
                      </thead>
                      <tbody>
            
                        <tr  >
                          <td>FIRST 6</td>
                          <td class="text-left">LKR {{item?.klhPrices?.first6}} 
                            <br> or
                            <br> LKR {{item?.klhPrices?.first65or4}}
                            <p class="winner-text-s">For 5 or 4</p>
                          </td>
                          <td></td>
                          <td>
                            <div class="icon-box">
                              <div *ngFor="let position of item?.eventPositions" class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                                  'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                                  'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                                  'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                                  }"
                                class="numberCircle">{{position.selectionNumber}}</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td>FIRST 5</td>
                          <td class="text-left">LKR {{item?.klhPrices?.first5}}
                            <br> or
                            <br> LKR {{item?.klhPrices?.first54or3}}
                            <p class="winner-text-s">For 4 or 3</p>
                          </td>
                          <td></td>
                          <td>
                            <div class="icon-box">
                              <div *ngFor="let position of item?.eventPositions | slice:0:5" class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                                  'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                                  'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                                  'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                                  }"
                                class="numberCircle">{{position.selectionNumber}}</span>
                              </div>                    
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td>FIRST 4</td>
                          <td class="text-left">LKR {{item?.klhPrices?.first4}}
                            <br> or
                            <br> LKR {{item?.klhPrices?.first43or2}}
                            <p class="winner-text-s">For 3 or 2</p>
                          </td>
                          <td></td>
                          <td>
                            <div class="icon-box">
                              <div *ngFor="let position of item?.eventPositions | slice:0:4" class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                                  'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                                  'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                                  'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                                  }"
                                class="numberCircle">{{position.selectionNumber}}</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr  >
                          <td>FIRST 3</td>
                          <td class="text-left">LKR {{item?.klhPrices?.first3}}
                            <br> or
                            <br> LKR {{item?.klhPrices?.first32}}
                            <p class="winner-text-s">For 2</p>
                          </td>
                          <td></td>
                          <td>
                            <div class="icon-box">
                              <div *ngFor="let position of item?.eventPositions | slice:0:3" class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                                  'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                                  'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                                  'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                                  }"
                                class="numberCircle">{{position.selectionNumber}}</span>
                              </div> 
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td>FIRST 2</td>
                          <td class="text-left">LKR {{item?.klhPrices?.first2}}
                            <br> or
                            <br> LKR {{item?.klhPrices?.first21}}
                            <p class="winner-text-s">For 1</p>
                          </td>
                          <td></td>
                          <td>
                            <div class="icon-box">
                              <div *ngFor="let position of item?.eventPositions | slice:0:2" class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                                  'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                                  'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                                  'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                                  }"
                                class="numberCircle">{{position.selectionNumber}}</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr  >
                          <td>WINNER</td>
                          <td class="text-left">LKR {{item?.klhPrices?.winnerNumber}}
                            <p class="winner-text-s">Number</p>
                          </td>
                          <td class="text-left">LKR {{item?.klhPrices?.winnerColor}}
                            <p class="winner-text-s">Color</p>
                          </td>
                          <td>
                            <div class="icon-box">
                              <div *ngFor="let position of item?.eventPositions | slice:0:1" class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(position) == 'red', 'blue-button' : checkKr3Color(position) == 'blue' ,
                                  'green-button': checkKr3Color(position) == 'green', 'yellow-button' : checkKr3Color(position) == 'yellow' ,
                                  'black-button': checkKr3Color(position) == 'black', 'purple-button' : checkKr3Color(position) == 'purple' ,
                                  'orange-button': checkKr3Color(position) == 'orange', 'white-button' : checkKr3Color(position) == 'white'
                                  }"
                                class="numberCircle">{{position.selectionNumber}}</span>
                              </div>                     
                            </div>
                          </td>
                        </tr>
                        <tr >
                          <td>1 IN FIRST 2</td>
                          <td class="text-left">LKR {{item?.klhPrices?.oneInFirst2Number}}</td>
                          <td></td>
                          <td>
                            <div *ngIf="item.eventPositions?.length>0" class="icon-box">
          
                              <div class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(item?.eventPositions[0]) == 'red', 'blue-button' : checkKr3Color(item?.eventPositions[0]) == 'blue' ,
                                  'green-button': checkKr3Color(item?.eventPositions[0]) == 'green', 'yellow-button' : checkKr3Color(item?.eventPositions[0]) == 'yellow' ,
                                  'black-button': checkKr3Color(item?.eventPositions[0]) == 'black', 'purple-button' : checkKr3Color(item?.eventPositions[0]) == 'purple' ,
                                  'orange-button': checkKr3Color(item?.eventPositions[0]) == 'orange', 'white-button' : checkKr3Color(item?.eventPositions[0]) == 'white'
                                  }"
                                class="numberCircle">{{item?.eventPositions[0].selectionNumber}}</span>
                              </div> 
          
                              <p class="or-text">OR</p>
          
                              <div class="dib">
                                <span 
                                [ngClass]="{'red-button': checkKr3Color(item?.eventPositions[1]) == 'red', 'blue-button' : checkKr3Color(item?.eventPositions[1]) == 'blue' ,
                                  'green-button': checkKr3Color(item?.eventPositions[1]) == 'green', 'yellow-button' : checkKr3Color(item?.eventPositions[1]) == 'yellow' ,
                                  'black-button': checkKr3Color(item?.eventPositions[1]) == 'black', 'purple-button' : checkKr3Color(item?.eventPositions[1]) == 'purple' ,
                                  'orange-button': checkKr3Color(item?.eventPositions[1]) == 'orange', 'white-button' : checkKr3Color(item?.eventPositions[1]) == 'white'
                                  }"
                                class="numberCircle">{{item?.eventPositions[1].selectionNumber}}</span>
                              </div>
                            </div>                  
                          </td>
                        </tr>
                        <tr  >
                          <td>LOW</td>
                          <td class="text-left">LKR {{item?.klhPrices?.lowFirstNumber}}</td>
                          <td></td>
                          <td class="text-left">{{item?.klhWinnerLowHigh}}</td>
                        </tr>
                        <tr  >
                          <td>ODD/EVEN</td>
                          <td class="text-left">LKR {{item?.klhPrices?.oddFirstNumber || item?.klhPrices?.evenFirstNumber}}</td>
                          <td></td>
                          <td class="text-left">{{item?.klhWinnerOddEven}}</td>
                        </tr>
                        
                      </tbody>
                    </table>
                  </div>
                  
                </div>

                
              </div>


            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>